<template>
  <div class="page-wrap p-3">
    <div class="page-header p-3 mb-3 mt-3">
      <h3>Сверка актов</h3>
      <div class="add-item-block mt-3 mb-3 d-flex justify-content-end">
        <b-button v-if="hasRoleAccess(adminRoles)" variant="success" @click="onClickAdd()">
          Добавить БИН
        </b-button>
      </div>
      <div class="filters">
        <div class="row col-md-6">
          <div class="el-input-group">
            <label for="bin" class="form-label col-md-3"></label>
            <div class="col-md-9">
              <div class="input-group">
                <input class="form-control" type="text" placeholder="Поиск по БИН/Номер акта"
                       id="bin"
                       v-model="page.filter.search"
                       style="font-style: italic;">
                <button class="btn btn-primary" type="button" @click="reloadList()">
                  Найти
                </button>
                <label v-if="hasRoleAccess(adminWriteRoles)" class="ms-3 align-self-center">
                  <input type="checkbox" v-model="page.filter.includeDeleted" @change="reloadList()"> Показать удалённые
                </label>
              </div>
            </div>
          </div>
        </div>

        <div class="row col-md-6">
          <div class="el-input-group">
            <label for="filterMonth" class="form-label col-md-3">
              Учетный месяц
            </label>
            <div class="col-md-9">
              <select v-model="page.filter.month" id="filterMonth"
                      v-on:change="reloadList()"
                      class="form-select">
                <option v-for="(monthName, index) in months" :key="index" :value="index + 1">
                  {{ monthName }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="row col-md-6">
          <div class="el-input-group">
            <label for="filterYear" class="form-label col-md-3">
              Учетный год
            </label>
            <div class="col-md-9">
              <select v-model="page.filter.year" id="filterYear"
                      v-on:change="reloadList()"
                      class="form-select">
                <option v-for="(year, index) in years" :key="index" :value="year">
                  {{ year }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="row col-md-6">
          <div class="el-input-group">
            <label for="status" class="form-label col-md-3">
              Статус сверки
            </label>
            <div class="col-md-9">
              <select v-model="page.filter.verificationStatus" id="status"
                      v-on:change="reloadList()"
                      class="form-select">
                <option v-for="statusKey in Object.keys(verificationStatus)" :key="statusKey" :value="statusKey">
                  {{ verificationStatus[statusKey] }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="row col-md-6">
          <div class="el-input-group">
            <label for="status" class="form-label col-md-3">
              Населенный пункт
            </label>
            <div class="col-md-9">
              <multiselect
                  v-model="page.filter.kato"
                  :options="katoList"
                  :searchable="true"
                  :closeOnSelect="true"
                  :custom-label="formattedKatoLabel"
                  placeholder="Выберите Като"
                  :multiple="false"
                  :clear-on-select="true"
                  @select="reloadList()"
              />
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
  <div class="page-content mt-3 mb-3">
    <div class="page-content-info d-flex align-items-center justify-content-end">
      <b-button variant="success"
                :disabled="items.length === 0"
                @click="onClickGenerateReport()">
        Экспортировать в MS Excel
      </b-button>

      <b-button variant="success"
                style="margin-left: 10px"
                @click="onClickAllRefresh(page)">
        Запрос в АИИС ЭГЗ
      </b-button>
    </div>

    <button v-if="hasRoleAccess(adminRoles) && selectedLive.length > 0" @click="openDeletedModal" type="button" class="btn btn-danger">Удалить</button>
    <button v-if="hasRoleAccess(adminWriteRoles) && selectedDeleted.length > 0" @click="showRestoreModal = true" type="button" class="btn btn-success ms-2">Восстановить</button>
    <DeleteReasonDialog v-model="showRestoreModal" variant="restore" title="Восстановить выбранные акты?" confirm-text="Восстановить" reason-label="Причина восстановления" :loading="deleteLoading" @confirm="handleRestoreSelectedElements">
      <p>Выбрано актов: {{ selectedDeleted.length }}. Счета-фактуры по ним тоже будут восстановлены.</p>
    </DeleteReasonDialog>

    <div class="page-content-info d-flex align-items-center justify-content-between">
      <div>Найдено: <span>{{ totalCount }}</span></div>
    </div>

    <div class="col-md-4">
      <span>Элементов в странице: </span>
      <div class="btn-group" role="group">
        <button type="button" class="btn btn-secondary" :class="{'active': page.countInPage == 10}" @click="changePageElementSize(10)">10</button>
        <button type="button" class="btn btn-secondary" :class="{'active': page.countInPage == 50}" @click="changePageElementSize(50)">50</button>
        <button type="button" class="btn btn-secondary" :class="{'active': page.countInPage == 100}" @click="changePageElementSize(100)">100</button>
      </div>
    </div>

    <b-table striped hover
             :items="items"
             :fields="fields"
             :tbody-tr-class="rowClass"
             responsive="sm"
             no-local-sorting
             show-sort-labels>
      <template #head(bin)="data">
        <div class="sortable-container none"
             @click="onSortChanged('bin')"
             :class="{'ascending': page.sort.bin === 'ASC', 'descending': page.sort.bin === 'DESC'}">
          БИН ДО
        </div>
      </template>
      <template #head(lmsId)="data">
        <div class="sortable-container none"
             @click="onSortChanged('lmsId')"
             :class="{'ascending': page.sort.lmsId === 'ASC', 'descending': page.sort.lmsId === 'DESC'}">
          ID LMS
        </div>
      </template>
      <template #head(signedAmount)="data">
        <div class="sortable-container none"
             @click="onSortChanged('signedAmount')"
             :class="{'ascending': page.sort.signedAmount === 'ASC', 'descending': page.sort.signedAmount === 'DESC'}">
          <span style="color: green;">Сумма подписанного расчета</span>
        </div>
      </template>
      <template #head(prevMonthSignedAmount)="data">
        <div class="sortable-container none"
             @click="onSortChanged('prevMonthSignedAmount')"
             :class="{
               'ascending': page.sort.prevMonthSignedAmount === 'ASC',
               'descending': page.sort.prevMonthSignedAmount === 'DESC',
               }">
          <span style="color: #FFD700;">Сумма подписанного расчета пред месяца</span>
        </div>
      </template>
      <template #head(actId)="data">
        <div class="actId sortable-container none"
             @click="onSortChanged('actId')"
             :class="{'ascending': page.sort.actId === 'ASC', 'descending': page.sort.actId === 'DESC'}">
          ID Акта
        </div>
      </template>
      <template #head(numberAct)="data">
        <div class="sortable-container none"
             @click="onSortChanged('numberAct')"
             :class="{'ascending': page.sort.numberAct === 'ASC', 'descending': page.sort.numberAct === 'DESC'}">
          Номер акта
        </div>
      </template>
      <template #head(verificationStatus)="data">
        <div class="sortable-container none"
             @click="onSortChanged('verificationStatus')"
             :class="{'ascending': page.sort.verificationStatus === 'ASC', 'descending': page.sort.verificationStatus === 'DESC'}">
          Статус сверки
        </div>
      </template>
      <template #head(kindergartenName)="data">
        <div class="sortable-container none"
             @click="onSortChanged('kindergartenName')"
             :class="{'ascending': page.sort.kindergartenName === 'ASC', 'descending': page.sort.kindergartenName === 'DESC'}">
          Наименование ДО
        </div>
      </template>
      <template #head(locality)="data">
        <div class="sortable-container none"
                   @click="onSortChanged('locality')"
             :class="{'ascending': page.sort.locality === 'ASC', 'descending': page.sort.locality === 'DESC'}">
          Населенный пункт
        </div>
      </template>

      <template v-if="hasRoleAccess(adminRoles)" #cell(kindergartenCalculationId)="data">
        <label class="btn btn-outline-light">
          <input type="checkbox" :value="data.item" v-model="selectedKindergartenCalculations">
        </label>
      </template>
      <template #cell(bin)="data">
        {{ data.item.bin }}
      </template>
      <template #cell(lmsId)="data">
        {{ data.item.lmsId }}
      </template>
      <template #cell(signedAmount)="data">
        <p :class="{'text-danger': Math.abs(data.item.signedAmount - data.item.prevMonthSignedAmount)/data.item.prevMonthSignedAmount >= 0.3}">
          {{ formatPrice(data.item.signedAmount) }}
        </p>
      </template>
      <template #cell(prevMonthSignedAmount)="data">
        <p :class="{
          'text-danger': Math.abs(data.item.signedAmount - data.item.prevMonthSignedAmount)/data.item.prevMonthSignedAmount >= 0.3,
          'text-success': Math.abs(data.item.signedAmount - data.item.prevMonthSignedAmount)/data.item.prevMonthSignedAmount === 0,
        }">
          {{ formatPrice(data.item.prevMonthSignedAmount) }}
        </p>
      </template>
      <template #cell(actId)="data">
        <div class="input-group" v-if="data.item.verificationStatus !== VerificationStatusEnum.SUCCESSFUL">
          <input v-model="data.item.actId" name="inputActId" type="text" class="form-control inputActId"/>
          <button @click="onClickRefreshStatus(data.item)"
                  :disabled="data.item.actId == null"
                  name="btnRefresh"
                  class="btn btn-outline-secondary">
            <font-awesome-icon icon="sync"/>
          </button>
        </div>
        <div class="input-group" v-if="data.item.verificationStatus === VerificationStatusEnum.SUCCESSFUL">
          {{ data.item.actId }}
        </div>
      </template>
      <template #cell(numberAct)="data">
        {{ data.item.numberAct }}
      </template>
      <template #cell(verificationStatus)="data">
        {{ getStatus(data.item.verificationStatus) }}
      </template>
      <template #cell(kindergartenName)="data">
        {{ data.item.kindergartenName }}
      </template>
      <template #cell(locality)="data">
        {{ data.item.locality }}
      </template>
    </b-table>
  </div>
  <div class="page-footer">
    <b-pagination
        v-model="page.partNumber"
        :total-rows="totalCount"
        :per-page="page.countInPage"
        v-on:click="reloadList"
        first-text="<<"
        last-text=">>"
        class="mt-3"
    ></b-pagination>
  </div>

  <!-- Modal component -->
  <b-modal v-model="showModal" hide-footer="" title="Добавление БИН для сверки акта">
    <form @submit.prevent="submitForm" class="mb-4">
      <div class="mb-3">
        <label for="month" class="form-label">
          Учетный месяц
          <span class="text-danger">*</span>
        </label>
        <select v-model="form.filter.month" id="month"
                class="form-select" required>
          <option disabled value="">Выберите месяц</option> <!-- Placeholder -->
          <option v-for="(monthName, index) in months" :key="index" :value="index + 1">
            {{ monthName }}
          </option>
        </select>
      </div>

      <div class="mb-3">
        <label for="year" class="form-label">
          Учетный год
          <span class="text-danger">*</span>
        </label>
        <select v-model="form.filter.year" id="year" required
                class="form-select">
          <option disabled value="">Выберите год</option> <!-- Placeholder -->
          <option v-for="(year, index) in years" :key="index" :value="year">
            {{ year }}
          </option>
        </select>
      </div>

      <div class="mb-3">
        <label for="bins" class="form-label">
          БИНы ДО
          <span class="text-danger">(Укажите БИНы или LmsID-шки)</span>
        </label>
        <textarea v-model="form.filter.binsText" id="bins" rows="5"
                  placeholder="Введите БИНы ДО (через запятую)"
                  class="form-control"/>
      </div>

      <div class="mb-3">
        <label for="lmsIds" class="form-label">
          LmsID-шки ДО
          <span class="text-danger">(Укажите БИНы или LmsID-шки)</span>
        </label>
        <textarea v-model="form.filter.lmsIdsText" id="lmsIds" rows="5"
                  placeholder="Введите lms id-шки ДО (через запятую)"
                  class="form-control"/>
      </div>
      <div v-if="formErrors.length" class="alert alert-danger">
        <ul>
          <li v-for="(error, index) in formErrors" :key="index">{{ error }}</li>
        </ul>
      </div>

      <div class="text-end">
        <button type="submit" class="btn btn-success">Save</button>
      </div>
    </form>
  </b-modal>

  <DeleteReasonDialog v-model="showDeleteConfirmationModal" title="Вы точно хотите удалить выбранные Акты?" :loading="deleteLoading" @confirm="handleDeleteSelectedElements">
    <el-table :data="deletedConfirmationContent">
      <el-table-column prop="bin" label="БИН ДО"></el-table-column>
      <el-table-column prop="lmsId" label="LMS ID"></el-table-column>
      <el-table-column prop="actId" label="ID Акта"></el-table-column>
      <el-table-column prop="numberAct" label="Номер Акта"></el-table-column>
    </el-table>
  </DeleteReasonDialog>

  <vue-loading :active.sync="isLoading" :is-full-page="true"></vue-loading>
</template>

<script>

import {
  createActReconciliation, deleteActByKindergartenCalculationIdList, restoreActByKindergartenCalculationIdList,
  generateReport,
  getAllActReconciliations,
  refreshActReconciliation, refreshAllActReconciliation
} from "@/services/actService";
import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import {VerificationStatusEnum} from "@/enums/VerificationStatus";
import {saveAs} from "@/assets/FileSaver.min.js";
import {TemplateTypeEnum} from "@/enums/TemplateType";
import Multiselect from "vue-multiselect";
import cacheService from "@/services/cacheService";
import authService from "@/services/authService";
import {ref, watch} from "vue";
import {ElMessage, ElMessageBox} from "element-plus";
import DeleteReasonDialog from "@/components/DeleteReasonDialog.vue";
import {extractApiError} from "@/utils/apiError";
import {DELETE_CONFIRMATION_REQUIRED} from "@/types/deleteRequest";

export default {
  computed: {
    VerificationStatusEnum() {
      return VerificationStatusEnum
    },
    selectedLive() {
      return this.selectedKindergartenCalculations.filter(item => !item?.deletion);
    },
    selectedDeleted() {
      return this.selectedKindergartenCalculations.filter(item => !!item?.deletion);
    }
  },
  components: {
    Multiselect,
    VueLoading,
    DeleteReasonDialog
  },
  data() {
    return {
      showModal: false,
      isLoading: false,
      form: {
        filter: {
          month: '',
          year: '',
          bins: [],
          binsText: '',
          lmsIdList: [],
          lmsIdsText: '',
        }
      },
      page: {
        filter: {
          year: new Date().getFullYear(),
          month: new Date().getMonth() + 1,
          search: null,
          bins: null,
          verificationStatus: VerificationStatusEnum.ALL,
          kato: null,
          includeDeleted: false
        },
        sort: {},
        partNumber: 1,
        countInPage: 10,
      },
      totalCount: 0,
      months: [
        'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
        'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'
      ],
      years: Array.from({length: 11}, (v, i) => 2024 + i),
      fields: [
        {key: 'kindergartenCalculationId', label: '#', sortable: false},
        {key: 'bin', label: 'БИН ДО', sortable: true},
        {key: 'lmsId', label: 'ID LMS', sortable: true},
        {key: 'signedAmount', label: 'Сумма подписанного расчета', sortable: true},
        {key: 'prevMonthSignedAmount', label: 'Сумма подписанного расчета пред месяца', sortable: true},
        {key: 'actId', label: 'ID Акта', sortable: true},
        {key: 'numberAct', label: 'Номер акта', sortable: true},
        {key: 'verificationStatus', label: 'Статус сверки', sortable: true},
        {key: 'kindergartenName', label: 'Наименование ДО', sortable: true},
        {key: 'locality', label: 'Населенный пункт', sortable: true}
      ],
      items: [],
      verificationStatus: {
        ALL: 'Все',
        NONE: 'Сверка еще не проводилась',
        SUCCESSFUL: 'Успешно',
        INVALID_ACT_NUMBER: 'Некорректный номер акта',
        VERIFICATION_FAILED: 'Проверка не прошла',
        APPROVAL_REQUIRED: 'Требуется согласование на портале',
        LMS_SUSPENDED: 'ДО в стоп листе',
        REFUSED_TO_ACCEPT: 'Отказано в принятии'
      },
      katoList: [],
      formErrors: [], // Для хранения ошибок
      showDeleteConfirmationModal: false,
      showRestoreModal: false,
      deleteLoading: false,
      adminWriteRoles: [],
      selectedKindergartenCalculations: [],
      deletedConfirmationContent: {},
      adminRoles: []
    };
  },

  methods: {



    onClickAdd() {
      this.showModal = true;
      this.form.month = '';
      this.form.year = '';
      this.form.bins = [];
      this.form.binsText = '';
      this.form.lmsIdList = '';
      this.form.lmsIdsText = '';
    },
    async submitForm() {
      if ((this.form.filter.binsText.length > 0 && this.form.filter.lmsIdsText.length > 0)
          || (this.form.filter.binsText.length === 0 && this.form.filter.lmsIdsText.length === 0)) {
        this.formErrors = ['Невозможно использовать одновременно БИНы и LmsID. Укажите только одно из полей. Одно из них обязательно.'];
        return;
      } else {
        this.formErrors = [];
      }

      const binsArray = this.form.filter.binsText.split(',');
      this.form.filter.bins = binsArray.map(bin => bin.trim());
      this.form.filter.lmsIdList = this.form.filter.lmsIdsText;

      const token = localStorage.getItem("access_token");
      if (token) {
        this.isLoading = true;
        await createActReconciliation(token, this.form);
        this.isLoading = false;
        this.showModal = false;
        this.reloadList();
      }
    },
    async onClickGenerateReport() {
      const token = localStorage.getItem("access_token");
      if (token) {
        this.isLoading = true;
        const response = await generateReport(token, TemplateTypeEnum.ACT_RECONCILIATION_XLSX, this.page);
        const blob = new Blob([response.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
        saveAs(blob, "document.xlsx");
        this.isLoading = false;
      }
    },
    async onClickRefreshStatus(item) {
      const token = localStorage.getItem("access_token");
      if (token) {
        this.isLoading = true;
        const updatedItem = await refreshActReconciliation(token, item);
        Object.assign(item, updatedItem);
        this.isLoading = false;
      }
    },
    async onClickAllRefresh(page) {
        this.isLoading = true;
        await refreshAllActReconciliation(page, 'refresh');

      this.reloadList();

        this.isLoading = false;
    },
    async fetchCachedDatas() {
      this.katoList = await cacheService.useKatoStore().fetchKato();
    },
    formattedKatoLabel(item){
      return `${item.code} | ${item.nameRu}`;
    },
    async reloadList() {
      const token = localStorage.getItem("access_token");
      if (token) {
        this.isLoading = true;
        const response = await getAllActReconciliations(token, this.page);
        this.items = response.list;
        this.totalCount = response.count;
        this.isLoading = false;
      }
    },
    getStatus(status) {
      return this.verificationStatus[status] || 'Неизвестный статус';
    },
    onSortChanged(column) {
      this.page.sort = {
        ...this.page.sort,
        [column]: this.page.sort[column] === 'ASC' ? 'DESC' : 'ASC'
      };

      this.reloadList();
    },

    changePageElementSize(pageSize) {
      this.page.countInPage = pageSize;
      this.reloadList();
    },

    openDeletedModal() {
      this.showDeleteConfirmationModal = true
      this.deletedConfirmationContent = this.selectedKindergartenCalculations.map((i) => ({
        bin: i.bin,
        lmsId: i.lmsId,
        actId: i.actId,
        numberAct: i.numberAct
      }));
    },

    rowClass(item) {
      return item?.deletion ? "deleted-row" : "";
    },
    async handleRestoreSelectedElements(reason) {
      this.deleteLoading = true;
      const ids = this.selectedDeleted.map(item => item.kindergartenCalculationId);
      try {
        await restoreActByKindergartenCalculationIdList(ids, reason);
        location.reload();
        return;
      } catch (error) {
        ElMessage({ message: extractApiError(error, "Восстановление не прошло"), type: "error", showClose: true });
      }
      this.deleteLoading = false;
    },
    async handleDeleteSelectedElements(reason, confirmReconciled = false) {
      this.deleteLoading = true;
      const selectedIdList = this.selectedLive.map(item => item?.kindergartenCalculationId ?? null).filter(id => id != null);
      if (selectedIdList.length > 0) {
        try {
          const responseStatus = await deleteActByKindergartenCalculationIdList(selectedIdList, reason, confirmReconciled);
          if (responseStatus === 200) {
            location.reload();
            return;
          }
          ElMessage({ message: "Неизвестная ошибка, удаление не прошло", type: "error", showClose: true });
        } catch (error) {
          if (!confirmReconciled && error?.response?.data?.code === DELETE_CONFIRMATION_REQUIRED) {
            this.deleteLoading = false;
            if (await this.confirmReconciledDelete(extractApiError(error))) {
              await this.handleDeleteSelectedElements(reason, true);
            }
            return;
          }
          ElMessage({ message: extractApiError(error, "Удаление не прошло"), type: "error", showClose: true });
        }
      }
      this.deleteLoading = false;
    },
    confirmReconciledDelete(details) {
      return ElMessageBox.confirm(
          `${details}. Вы точно хотите удалить?`,
          "Счёт-фактура успешно сверен",
          { type: "warning", confirmButtonText: "Удалить", cancelButtonText: "Отмена" }
      ).then(() => true).catch(() => false);
    },
    hasRoleAccess(roles) {
      return authService.hasAccess(roles);
    },

    formatPrice(price) {
      return price.toLocaleString('ru-RU', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
  },

  mounted() {
    this.reloadList();
    this.fetchCachedDatas();
    this.adminRoles = authService.getAdminRoles();
    this.adminWriteRoles = authService.getAdminWriteRoles();
  },
};
</script>

<style scoped>

.open-modal-btn {
  display: block;
  margin: 20px auto;
  padding: 10px 20px;
  background-color: #4caf50;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.open-modal-btn:hover {
  background-color: #45a049;
}

.modal {
  display: block;
  position: fixed;
  z-index: 5;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.modal-content {
  background-color: #fefefe;
  margin: 15% auto;
  padding: 20px;
  border: 1px solid #888;
  width: 400px;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}

.filters {
  .row {
    padding-top: 5px;
  }
}

.ascending {
  background-image: url("../assets/asc.svg") !important;
}

.descending {
  background-image: url("../assets/desc.svg") !important;
}

.none {
  background-image: url("../assets/none.svg");
  margin-left: 10px !important;
}

.sortable-container {
  background-position: right calc(0.75rem / 2) center;
  background-repeat: no-repeat;
  background-size: 0.65em 1em;
  vertical-align: middle !important;
  margin-right: 10px !important;
  padding-right: 15px !important;
  cursor: pointer;
}

th div {
  width: 100% !important;
  display: grid !important;
}

</style>

<style>
.table tr.deleted-row td {
  background-color: #fdecea;
  color: #8a8a8a;
}
</style>
